// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileTextOutlinedSvg from "@ant-design/icons-svg/es/asn/FileTextOutlined";
import AntdIcon from '../components/AntdIcon';

var FileTextOutlined = function FileTextOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileTextOutlinedSvg
  }));
};

FileTextOutlined.displayName = 'FileTextOutlined';
export default React.forwardRef(FileTextOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileTextOutlined.js
// module id = 1145
// module chunks = 0